export const isDarkOrLightByElement = (element) => {
  try {
    const colors = getComputedStyle(element).getPropertyValue('background-color').match(new RegExp(/(\d|,|\.|\s)+/, 'g'))[0].split(',')
    if (colors.length > 3) {
      return 'dark'
    }
    const yiq = ((parseInt(colors[0], 10) * 299) + (parseInt(colors[1], 10) * 587) + (parseInt(colors[2], 10) * 114)) / 1000
    return (yiq >= 128) ? 'dark' : 'light'
  } catch (error) {
    return 'dark'
  }
}

export const isDarkOrLightByHex = (hex) => {
  try {
    const yiq = ((parseInt(hex.substr(1, 2), 16) * 299) + (parseInt(hex.substr(3, 2), 16) * 587) + (parseInt(hex.substr(5, 2), 16) * 114)) / 1000
    return (yiq >= 128) ? 'dark' : 'light'
  } catch (error) {
    return 'dark'
  }
}
